import styled from 'styled-components';

const IconButton = styled.button`
  padding: ${({ theme }) => theme.spacing.sm};
  border-radius: 50%;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  background: none;
  color: ${({ theme, variant }) => 
    variant === 'danger' ? theme.colors.error : theme.colors.text};
  opacity: 0.6;

  &:hover {
    background: ${({ theme, variant }) => 
      variant === 'danger' 
        ? `${theme.colors.error}10` 
        : `${theme.colors.primary}10`
    };
    color: ${({ theme, variant }) => 
      variant === 'danger' 
        ? theme.colors.error 
        : theme.colors.primary
    };
    opacity: 1;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export default IconButton; 